import React, { useState } from 'react'
import { View, Image } from 'react-native'
import { Icon } from 'react-native-elements'
import Colors from '../../../constants/Colorsv2'
import { Text, TouchableOpacity } from '../../../globalComponents/NativeOverrides'
import { PublicPlayerProps } from "../../../store/types/auth_svc"
import ActionModal from '../../../Componentsv1/ActionModal';
import { useDispatch } from 'react-redux'
import { social_updatePost } from '../../../store/actionsv1/social'
import moment from 'moment'
import { Battle, PremiumBadge } from '../../../Componentsv1/Icons'
import { BadgeProps } from '../../../store/types/soc_svc'
import BadgeCard from './Badge'
import { navigate } from '../../../navigation/RootNavigation'
import { BELinkApi } from '../../../AnalyticsObserver'

type PlayerCardHeaderProps = {
    player: PublicPlayerProps,
    post_id:string,
    company?:PublicPlayerProps,
    create_datetime:string,
    viewer_id: string,
    hide_actions?:boolean,
    onActionPress: (action:string) => void
}

const PostCardHeader = ({ post_id, viewer_id, player, create_datetime, company, hide_actions, onActionPress }:PlayerCardHeaderProps) => {
    const [ action_visible, setActionVisible ] = useState(false);

    let options = [
        { option:'share', label: 'Share & Create Post', color:Colors.brand.midnight },
        { option: 'native_share', label: 'Share Externally', color:Colors.brand.midnight }
    ]

    if(viewer_id == player.player_id){
        options = options.concat([
            { option: 'edit', label: 'Edit', color:Colors.brand.midnight },
            { option: 'delete', label: 'Delete', color:Colors.utility.error }
        ])
    }

    const handleAction = (option:any) => {
        if(!onActionPress){ return }
        onActionPress(option.option)
    }

 
    if(!player) { return <></> } 

    return (
        <View style={{flexDirection:'row', justifyContent:'space-between', alignItems:'center'}}>
            <View style={{flex:1, flexDirection:'row', alignItems:'center'}}>
                <TouchableOpacity onPress={() => handleAction({ option: 'view' })}>
                    <Image style={{height:40, width:40, borderRadius:100}} source={player.profile_pic && player.profile_pic !== '' ? { uri: player.profile_pic }:require('../../../assets/images/default-avatar.png')} />
                    { company?
                        <Image style={{ position:'absolute', bottom:0, right:0, height:20, width:20, borderRadius:100, borderWidth:1, borderColor:Colors.shades.white}} source={company.profile_pic && company.profile_pic !== '' ?{ uri: company.profile_pic }:require('../../../assets/images/default-avatar.png')} />
                    :<></>}
                </TouchableOpacity>
                <View style={{flex:1, marginLeft:16}}>
                    <View style={{flexDirection:'row', alignItems:'center'}}>
                        <Text size={14} color={Colors.brand.midnight} weight='semibold'>{player.first_name} {player.last_name}</Text>
                    </View>
                    <Text style={{ flex:1 }} size={14} color={Colors.brand.slate} weight='regular'>@{player.username}{company?` for ${company.first_name} ${company.last_name}`:''} • {moment(create_datetime).fromNow()}</Text>
                </View>
            </View>
            {player.type == 'premium' ?
            <TouchableOpacity style={{ padding:5 }}
            onPress={() => navigate('AuthStack', { screen: 'Premium' })}>
                <PremiumBadge size={24} color={Colors.incentive.gold} />

            </TouchableOpacity>
            :<></>}
            {!hide_actions ?
            <View style={{ flexDirection:'row', alignItems:'center' }}>
                {viewer_id != player.player_id && player.role != 'company' ?
                <TouchableOpacity style={{ padding:10 }} onPress={() => onActionPress('challenge')}>
                    <Battle size={24} color={Colors.brand.midnight}/>
                </TouchableOpacity>
                :<></>}
                <TouchableOpacity style={{ padding:10 }} onPress={() => setActionVisible(true)}>
                    <Icon name='more-vertical' type='feather' color={Colors.brand.midnight} size={18} />
                </TouchableOpacity>
            </View>
            :<></>}
            {!hide_actions ?
            <ActionModal 
                options={options}
                label_attribute='label'
                onSelectOption={(option) => handleAction(option)}
                closeModal={() => setActionVisible(false)}
                isVisible={action_visible}
            />
            :<></>}
        </View>
    )
}

export default React.memo(PostCardHeader, (left, right) => {
    if(left.post_id != right.post_id){ return false }
    if(left.player?.player_id != right.player?.player_id){ return false }
    return true
})